// removed by extract-text-webpack-plugin
module.exports = {"center":"_1GcH4Xd04UePCsK1rY2IVb","DownloadPopup":"_2g38dPM_1tz06iHru_SrtZ","DownloadPopup__inner":"QUJ53VQ3KUjSqqoyuwLmh","DownloadPopup__Title":"_19A2W2ggpO4uPYSuG62oF6","DownloadPopup__Date":"_2NYU0ju1VuC43VT2N495v1","DownloadPopup__ChangeLog-title":"_2zm6M0PS6fwgmcj65rCBj-","DownloadPopup__DownloadButton":"_1lF5s_JeVRD9YI2eRaPjN","DownloadPopup__DownloadSelect":"nH0fS_5ogwNiEgNKHjJGt","DownloadPopup__OlderVersions":"_2_iWEi3er6bej8iYdoLIb8","DownloadPopup__ChangeLog":"_1DjLVSAChV5uOt9GDcJnHm","Featured":"_3kpr0K6YrKTtcHoGebJFBn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SoftwareDownloadPopupLatest/SoftwareDownloadPopupLatest.scss
// module id = 1227
// module chunks = 0